import { render, staticRenderFns } from "./investOrder.vue?vue&type=template&id=d31b0912&scoped=true&"
import script from "./investOrder.vue?vue&type=script&lang=js&"
export * from "./investOrder.vue?vue&type=script&lang=js&"
import style0 from "./investOrder.vue?vue&type=style&index=0&id=d31b0912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31b0912",
  null
  
)

export default component.exports